import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Tag } from 'entities/tag'
import { ReactNode, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Form } from 'utils/hooks'
import { TagViewModel } from 'view_models/tag_view_model'

export const tagColumnInfoList = (form?: Form<Record<string, unknown>>, type?: string): ColumnInfoList => {
    const values: ColumnInfo[] = [
        { name: 'CreateDate', th: true, width: 150, form: form, orderAttr: 'tag_created_at', searchType: { name: 'created_at', type: 'date' } },
        { name: 'Name', th: true, width: 150, form: form, orderAttr: 'tag_name', searchType: { name: 'name', type: 'text' } },
    ]

    if (type === 'probe') {
        values.push({ name: 'Probes', th: true, width: 150 })
    }

    values.push({ name: 'Note', th: true, minWidth: 300, form: form, orderAttr: 'tag_note', searchType: { name: 'note', type: 'text' } })
    return {
        tableName: '',
        values: values,
    }
}

export type TagTableDataProps = {
    tag?: Tag
    displaySetting: DisplaySetting
    type?: string
}

export const TagTableData = (props: TagTableDataProps): JSX.Element => {
    if (!props.tag) {
        return (
            <>
                {props.displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (props.displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const vm = new TagViewModel(props.tag!)
        return (
            <>
                <TableCell>{vm.createdAtText()}</TableCell>
                <TableCell>{props.tag?.name}</TableCell>
                {props.type === 'probe' && (
                    <TableCell>
                        <Link to={`probes?tags_in=${props.tag?.name}`}>{props.tag?.probeCount} probes</Link>
                    </TableCell>
                )}
                <TableCell>{props.tag?.note}</TableCell>
            </>
        )
    }, [props.displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !props.displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
